import React from 'react';
import classNames from 'classnames';
import Button, { ButtonContext } from '../button/Button';
import Icon from '../icon/Icon';
import Tag, { TagVariant } from '../tag/Tag';

const styles = require('./Card.module.scss');

export interface CardTag {
  children: React.ReactNode;
  icon?: string;
  variant: TagVariant;
}

export interface CardProps {
  allowMultiple?: boolean;
  children?: React.ReactNode;
  className?: string;
  context?: ButtonContext;
  iconName?: string;
  onAdd?: () => void;
  onEdit?: () => void;
  tag?: CardTag;
  title: string;
}

const Card: React.FC<CardProps> = ({
  allowMultiple = false,
  children,
  className,
  context = 'neutral',
  iconName,
  onAdd,
  onEdit,
  tag,
  title,
}) => {
  return (
    <section className={classNames(styles.container, className)} aria-label={title}>
      <div className={styles.header}>
        {iconName && (
          <div className={styles.iconWrapper}>
            <Icon name={iconName} color="disable" size="md" aria-hidden="true" />
          </div>
        )}
        <h3 className={styles.title}>{title}</h3>
        {tag && (
          <Tag variant={tag.variant} iconLeft={tag.icon}>
            {tag.children}
          </Tag>
        )}
        {onAdd && (allowMultiple || !children) && (
          <Button
            type="terceary"
            size="M"
            onClick={onAdd}
            iconLeft="plus"
            context={context}
            aria-label={`Add ${title.toLowerCase()}`}
          />
        )}
        {onEdit && !allowMultiple && children && (
          <Button
            type="terceary"
            size="M"
            onClick={onEdit}
            iconLeft="pencil"
            context={context}
            aria-label={`Edit ${title.toLowerCase()}`}
          />
        )}
      </div>
      {children}
    </section>
  );
};

export default Card;

export interface CardRowProps {
  children: React.ReactNode;
  context?: ButtonContext;
  label?: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

export const CardRow: React.FC<CardRowProps> = ({ children, context, label, onEdit, onDelete }) => {
  return (
    <div className={styles.row}>
      <div className={styles.rowContent}>
        {children}
      </div>
      <div className={styles.rowActions}>
        {onEdit && (
          <Button
            type="terceary"
            size="M"
            iconLeft="pencil"
            context={context}
            onClick={onEdit}
            className={styles.rowAction}
            aria-label={label ? `Edit ${label}` : 'Edit'}
          />
        )}
        {onDelete && (
          <Button
            type="terceary"
            size="M"
            iconLeft="trash"
            context={context}
            onClick={onDelete}
            className={styles.rowAction}
          />
        )}
      </div>
    </div>
  );
};
